import api from '../config/api';

const subscriptionAPI = {
  // Initiate subscription payment process
  initiateSubscription: async () => {
    try {
      const response = await api.post('/subscriptions/initiate');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'فشل في بدء عملية الاشتراك';
    }
  },

  // Verify subscription payment after Moyasar callback
  verifySubscription: async (subscriptionId, paymentId) => {
    try {
      const response = await api.post('/subscriptions/verify', {
        subscriptionId,
        paymentId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'فشل في التحقق من الاشتراك';
    }
  },

  // Get current subscription status
  getSubscriptionStatus: async () => {
    try {
      const response = await api.get('/subscriptions/status');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'فشل في الحصول على حالة الاشتراك';
    }
  }
};

export default subscriptionAPI;
